import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../state/inventoryState';

// Crea un slice de Redux para manejar el estado de la aplicación
const inventorySlice = createSlice({
    name: 'inventory',
    initialState,
    reducers: {
        setInventoryIts: (state, action) => {
            state.its = action.payload;
        },
        setInventoryEdification: (state, action) => {
            state.edification = action.payload;
        },
        setInventoryEnvironment: (state, action) => {
            state.environment = action.payload;
        },
        setInventoryInfraestructure: (state, action) => {
            state.infrastructure = action.payload;
        }
    },
});

// Exporta las acciones generadas por el slice
export const {
    setInventoryIts,
} = inventorySlice.actions;

// Exporta el reducer del slice
export default inventorySlice.reducer;
